import React from "react";
import { connect } from "react-redux";
import { SocialIcons } from "../../molecules/social-icons";
import get from "lodash/get";
import PT from "prop-types";
import "./footer.m.css";

function FooterBase(props) {
  const placeholders = props.menu.filter(
    item => item["item-type"] === "placeholder"
  );

  return (
    <footer styleName="footer">
      <div className="container">
        <div styleName="container">
          <ul styleName="menu-items">
            {placeholders.map(item => {
              return (
                <li key={item.id} styleName="menu-items-list">
                  <h5>{item.title}</h5>
                  <ul styleName="menu-items-list">
                    {item.children.map(child => (
                      <li key={child.id}>
                        <a href={child.completeUrl}>{child.title}</a>
                      </li>
                    ))}
                  </ul>
                </li>
              );
            })}
          </ul>
          {!props.domainSlug ? (
            <div styleName="social-links">
              <h5>Follow</h5>
              <SocialIcons
                socialLinks={props.socialLinks}
                showPodcast
                showTelegram
                showLinkedin
                showSpotify
                showCastBox
                showDiscord
                showRss
              />
            </div>
          ) : (
            <div styleName="social-links">
              <p>हमसे जुड़ें</p>
              <SocialIcons
                socialLinks={props.socialLinks}
                showDiscord
                showNewsletter
                showRSS
              />
            </div>
          )}
          <div styleName="about">
            {!props.domainSlug ? (
              <h5>With your support, we can do more ground-reports.</h5>
            ) : (
              <h5>
                आपका सहयोग हमें ज्यादा से ज्यादा ग्राउंड रिपोर्ट करने की ताकत
                देता है
              </h5>
            )}
            {!props.domainSlug ? (
              <a styleName="nl-btn" href="/sena?ref=website-footer">
                Join NL Sena
              </a>
            ) : (
              <a styleName="nl-btn" href={`/subscription?ref=footer-hindi`}>
                सब्सक्राइब करें
              </a>
            )}
          </div>
        </div>
        <div styleName="copyright">
          <p styleName="copyright-text">
            © Newslaundry Media Private Limited. All Rights Reserved.
          </p>
          <a href="https://www.quintype.com">
            <p styleName="copyright-text">Powered by Quintype</p>
          </a>
        </div>
      </div>
    </footer>
  );
}

FooterBase.propTypes = {
  menu: PT.arrayOf(
    PT.shape({
      completeUrl: PT.string,
      title: PT.string
    })
  ),
  socialLinks: PT.object,
  domainSlug: PT.string
};

function mapStateToProps(state) {
  const menu =
    get(state, ["qt", "data", "navigationMenu", "footerLinks"], []) ||
    get(state, ["qt", "data", "navigationMenu", "default"], []);
  return {
    menu: menu,
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    domainSlug: get(state, ["qt", "domainSlug"], null),
    frontEndUrl: get(state, ["qt", "config", "publisher", "frontend_url"], "")
  };
}

export const Footer = connect(mapStateToProps)(FooterBase);
